import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { SimpleHero } from 'components/SimpleHero';
import { ga } from 'helpers/multitrack';
import { pick } from 'helpers/object';
export var Template =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Template, _PureComponent);

  function Template(props) {
    var _this;

    _classCallCheck(this, Template);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Template).call(this, props));
    _this.handleCtaClick = _this.handleCtaClick.bind(_assertThisInitialized(_this));
    _this.handleView = _this.handleView.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Template, [{
    key: "handleView",
    value: function handleView() {
      var _this$props = this.props,
          eventName = _this$props.eventName,
          eventLabel = _this$props.eventLabel;

      if (eventName) {
        ga("".concat(eventName, " Module"), 'Viewed module', eventLabel || null, 0, {
          nonInteraction: true
        });
      }
    }
  }, {
    key: "handleCtaClick",
    value: function handleCtaClick() {
      var _this$props2 = this.props,
          eventName = _this$props2.eventName,
          eventLabel = _this$props2.eventLabel;

      if (eventName) {
        ga("".concat(eventName, " Module"), 'Clicked CTA', eventLabel);
      }
    }
  }, {
    key: "renderCta",
    value: function renderCta() {
      var _this$props3 = this.props,
          ctaCopy = _this$props3.ctaCopy,
          ctaLink = _this$props3.ctaLink,
          openInNewTab = _this$props3.openInNewTab;

      if (!ctaCopy) {
        return false;
      }

      var linkIsFullyQualified = ctaLink && ctaLink.indexOf('http') === 0;
      var useAnchor = linkIsFullyQualified || openInNewTab;
      var cta;

      if (useAnchor) {
        cta = React.createElement("a", _extends({
          onClick: this.handleCtaClick,
          href: ctaLink,
          className: "bt bt--primary bt--lg"
        }, openInNewTab ? {
          target: '_blank'
        } : {}), ctaCopy);
      } else {
        cta = React.createElement(Link, {
          onClick: this.handleCtaClick,
          to: ctaLink,
          className: "bt bt--primary bt--lg"
        }, ctaCopy);
      }

      return React.createElement("div", {
        className: "pt--"
      }, cta);
    }
  }, {
    key: "render",
    value: function render() {
      var passthroughProps = pick(['backgroundColor', 'body', 'children', 'footer', 'imageAlignment', 'imageAlt', 'imageUrl', 'title', 'titleSize'], this.props);
      return React.createElement(SimpleHero, _extends({}, passthroughProps, {
        cta: this.renderCta(),
        onView: this.handleView
      }));
    }
  }]);

  return Template;
}(PureComponent);

Template.propMapper = function (state, moduleDef) {
  return {
    title: moduleDef.title,
    titleSize: moduleDef.titleSize,
    backgroundColor: moduleDef.backgroundColor || 'white',
    body: moduleDef.body,
    footer: moduleDef.footer,
    imageAlignment: moduleDef.imageAlignment,
    imageUrl: moduleDef.image && moduleDef.image.image,
    imageAlt: moduleDef.image && moduleDef.image.altText,
    ctaCopy: moduleDef.cta && moduleDef.cta.title,
    ctaLink: moduleDef.cta && moduleDef.cta.url,
    openInNewTab: moduleDef.openInNewTab,
    eventName: moduleDef.eventName,
    eventLabel: moduleDef.eventLabel
  };
};

Template.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  backgroundColor: PropTypes.oneOf(['light', 'white']),
  footer: PropTypes.string,
  imageAlignment: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  ctaCopy: PropTypes.string,
  ctaLink: PropTypes.string,
  openInNewTab: PropTypes.bool,
  eventName: PropTypes.string,
  eventLabel: PropTypes.string,
  children: PropTypes.node
};